export default "__VITE_ASSET__CUieQmY3__"